/**
 * @description 总管理器，在这里控制其他子管理器，也作为3D内部使用的接口
 * @author TKB
 * @creat 2024-01-02 15:49:46
 */
import { LoadManager } from "./LoadManager.js";
import { SceneManager } from "./SceneManager.js";
import ResourceTracker from "../utils/ResourceTracker.js";
import { EventManager, EventManagerCommand } from "./EventManager.js";
import { InputManager } from "./InputManager.js";
import { VRSettingManager } from "./VRSettingManager.js";
import { VRManager } from "./VRManager.js";
import { ClippingManager } from "./ClippingManager.js";
import { MaterialManager } from "./MaterialManager.js";
import { HistoryManager } from "./HistoryManager.js";

export class Manager {
  constructor(el, options, otherArgs) {
    this.el = el;
    this.options = options ? options : {};

    this.useVR = otherArgs && otherArgs.useVR ? otherArgs.useVR : false;
    this.data = otherArgs && otherArgs.data ? otherArgs.data : null;

    this.isRunning = false;

    this.interface = null; // 外部使用的接口

    this.init();
  }

  init() {
    let scope = this;

    this.resourceTracker = new ResourceTracker();
    this.tracker = this.resourceTracker.track.bind(this.resourceTracker);

    this.eventManager = new EventManager(scope); // 事件管理器需要最先初始化
    this.sceneManager = new SceneManager(scope);
    this.inputManager = new InputManager(scope);
    this.loadManager = new LoadManager(scope);
    this.vrSettingManager = new VRSettingManager(scope);
    this.materialManager = new MaterialManager(scope);
    this.vrManager = new VRManager(scope);
    this.clippingManager = new ClippingManager(scope);
    this.historyManager = new HistoryManager(scope); // 历史记录管理器需要最后初始化

    this.isRunning = true;

    this.onKeyUpFunc = this.onKeyUp.bind(this);
    this.eventManager.addEventListener(
      EventManagerCommand.keyUp,
      this.onKeyUpFunc
    );
  }

  update(dt) {
    if (!this.isRunning) return;
    if (this.loadManager) this.loadManager.update(dt);
    if (this.eventManager) this.eventManager.update(dt);
    if (this.inputManager) this.inputManager.update(dt);
    if (this.materialManager) this.materialManager.update(dt);
    if (this.vrSettingManager) this.vrSettingManager.update(dt);
    if (this.vrManager) this.vrManager.update(dt);
    if (this.clippingManager) this.clippingManager.update(dt);
    if (this.historyManager) this.historyManager.update(dt);

    // other manager update

    // 场景更新要放最后面，不然如果有多个场景会有显示异常
    if (this.sceneManager) this.sceneManager.update(dt);
  }

  clear() {
    //console.log("manager.clear", this.sceneManager.renderer.info.memory);
    this.isRunning = false;
    if (this.resourceTracker) this.resourceTracker.dispose();
    if (this.loadManager) this.loadManager.clear();

    this.eventManager.removeEventListener(
      EventManagerCommand.keyUp,
      this.onKeyUpFunc
    );
    if (this.eventManager) this.eventManager.clear();
    if (this.inputManager) this.inputManager.clear();
    if (this.materialManager) this.materialManager.clear();
    if (this.vrSettingManager) this.vrSettingManager.clear();
    if (this.vrManager) this.vrManager.clear();
    if (this.clippingManager) this.clippingManager.clear();
    if (this.historyManager) this.historyManager.clear();

    // 这个放在最后
    if (this.sceneManager) this.sceneManager.clear();

    this.onKeyUpFunc = null;
  }

  /**
   * 返回当前是否是VR模式
   * @returns
   */
  isInVR() {
    if (!this.vrManager) return false;
    return this.vrManager.isInVr();
  }

  /**
   * 开启或关闭历史记录
   * @param {*} enable
   */
  enableHistory(enable = true) {
    if (this.historyManager) {
      if (enable) console.log("开启历史记录");
      else console.log("关闭历史记录");
      this.historyManager.historyDisabled = enable;
    }
  }

  /**
   * 增加历史记录
   * @param {*} cmd
   */
  addHistory(cmd) {
    if (this.historyManager) {
      this.historyManager.push(cmd);
    }
  }

  onKeyUp = (event) => {
    event = Array.isArray(event) ? event[0] : event;

    if (event.ctrlKey && event.key === "z") {
      // 撤销
      if (this.historyManager) {
        this.historyManager.undo();
      }
    } else if (event.ctrlKey && event.key === "y") {
      // 重做
      if (this.historyManager) {
        this.historyManager.redo();
      }
    }
  };
}
